
export const validateNumber = value => (
    value && isNaN(Number(value)) ? `Debe ser un número` : undefined
)

export const validatePositive = value => (
    value && value < 0 ? `Debe ser mayor o igual a 0` : undefined
)

export const validate = values => {
    const errors = {
        fields: []
    }

    if (!values.name) {
        errors.name = 'Requerido'
    }
    if (!values.description) {
        errors.description = 'Requerido'
    }

    if (!values.fields || !values.fields.length) {
        errors.fields = { _error: 'Debe crear al menos un campo' }
    } else {
        const fieldsArrayErrors = []
        values.fields.forEach((field, fieldIndex) => {
            const fieldErrors = {}
            if (!field || !field.name) {
                fieldErrors.name = 'Requerido'
                fieldsArrayErrors[fieldIndex] = fieldErrors
            }
            if (!field || !field.type) {
                fieldErrors.type = 'Requerido'
                fieldsArrayErrors[fieldIndex] = fieldErrors
            }
            if (field && field.minimum && field.maximum && field.minimum > field.maximum) {
                fieldErrors.minimum = 'Debe ser menor que el máximo'
                fieldErrors.maximum = 'Debe ser mayor que el minimo'
                fieldsArrayErrors[fieldIndex] = fieldErrors
            }
            if (field && field.minLength && field.maxLength && field.minLength > field.maxLength) {
                fieldErrors.minLength = 'Debe ser menor que el máximo'
                fieldErrors.maxLength = 'Debe ser mayor que el minimo'
                fieldsArrayErrors[fieldIndex] = fieldErrors
            }
        })
        if (fieldsArrayErrors.length) {
            errors.fields = fieldsArrayErrors
        }
    }

    return errors
}
